import { withAppCrashIfException } from 'epic';
import {
  underlyingsBlackoutDatesRequestedEpic,
  underlyingsSpecificDatesRequestedEpic,
} from 'epic/common-form/requestUnderlyingsDatesEpics';
import { requestBookingEpic } from 'epic/newDynamicForm/booking/requestBookingEpic';
import { combineEpics } from 'redux-observable';
import { dynamicScreenTabContentEpic } from 'state/workspaces/dynamic/tabContent';

import { cloneDynamicFormEpic } from './cloneDynamicFormEpic';
import { closeDynamicFormEpic } from './closeDynamicFormEpic';
import { costsAndChargeEpic } from './costsAndChargeEpic';
import { dynamicFormRollbackEpic } from './dynamicFormRollbackEpic';
import { dynamicWorkspaceRepriceEpic } from './dynamicWorkspaceRepriceEpic';
import { dynamicFormEnrichmentRequestedEpic } from './enrichment-requested';
import { fetchDefaultDynamicFormEpic } from './fetchDefaultDynamicFormEpic';
import { fetchDynamicFormWhenQuoteRepriceWithLastQuoteEpic } from './fetchDynamicFormWhenQuoteRepriceWithLastQuoteEpic';
import { fetchDynamicLastQuoteEpic } from './fetchDynamicLastQuote';
import { fetchDynamicWorkspaceTabsEpic } from './fetchDynamicWorkspaceTabsEpic';
import { kidDocumentEpic } from './kidDocumentEpic';
import { loadDynamicProductsEpic, navigateToDynamicWorkspaceEpic } from './navigateToDynamicWorkspaceEpic';
import { productGovernanceAssessmentEpic } from './productGovernanceAssessmentEpic';
import { productGovernanceDocumentEpic } from './productGovernanceDocumentEpic';
import { quoteResultEpic } from './quoteResultEpic';
import { removeDynamicQuote } from './removeDynamicQuoteEpic';
import { requestProductCodesEpic } from './requestProductCodesEpic';
import { requestQuoteEpic } from './requestQuoteEpic';
import { requestStreamingTradeEpic, requestTradeEpic } from './requestTradeEpic';
import { postReloadTradeAuthorizationEpic, tradeAuthorizationForQuoteEpic } from './tradeAuthorizationEpic';

export const dynamicFormEpic = () =>
  combineEpics(
    withAppCrashIfException('cloneDynamicFormEpic', cloneDynamicFormEpic()), // OK
    withAppCrashIfException('closeDynamicFormEpic', closeDynamicFormEpic()), // OK
    withAppCrashIfException('dynamic-costsAndChargeEpic', costsAndChargeEpic()), // OK
    withAppCrashIfException('fetchDefaultDynamicFormEpic', fetchDefaultDynamicFormEpic()),
    withAppCrashIfException(
      'fetchDynamicFormWhenQuoteRepriceWithLastQuoteEpic',
      fetchDynamicFormWhenQuoteRepriceWithLastQuoteEpic(),
    ),
    withAppCrashIfException('fetchDynamicLastQuoteEpic', fetchDynamicLastQuoteEpic()),

    withAppCrashIfException('fetchDynamicWorkspaceTabsEpi', fetchDynamicWorkspaceTabsEpic()),

    withAppCrashIfException('dynamic-kidDocumentEpic', kidDocumentEpic()), // OK
    withAppCrashIfException('navigateToDynamicWorkspaceEpic', navigateToDynamicWorkspaceEpic()),
    withAppCrashIfException('loadDynamicProductsEpic', loadDynamicProductsEpic()),
    withAppCrashIfException('dynamic-productGovernanceAssessmentEpic', productGovernanceAssessmentEpic()), // OK
    withAppCrashIfException('dynamic-productGovernanceDocumentEpic', productGovernanceDocumentEpic()), // OK

    withAppCrashIfException('dynamic-quoteResultEpic', quoteResultEpic()), // OK
    withAppCrashIfException('removeDynamicQuote', removeDynamicQuote()), // OK
    withAppCrashIfException('dynamic-requestQuoteEpic', requestQuoteEpic()), // OK
    withAppCrashIfException('dynamic-requestTradeEpic', requestTradeEpic()), // OK
    withAppCrashIfException('dynamic-requestStreamingTradeEpic', requestStreamingTradeEpic()), // OK
    withAppCrashIfException('dynamic-requestBookingEpic', requestBookingEpic()), // OK
    withAppCrashIfException('dynamicFormEnrichmentRequestedEpic', dynamicFormEnrichmentRequestedEpic()), // OK
    withAppCrashIfException('dynamicFormRollbackEpic', dynamicFormRollbackEpic()),
    withAppCrashIfException('dynamicScreenTabContentEpic', dynamicScreenTabContentEpic()),
    withAppCrashIfException('dynamicWorkspaceRepriceEpic', dynamicWorkspaceRepriceEpic()),
    withAppCrashIfException('dynamic-tradeAuthorizationForQuoteEpic', tradeAuthorizationForQuoteEpic()), // OK
    withAppCrashIfException('dynamic-postReloadTradeAuthorizationEpic', postReloadTradeAuthorizationEpic()), // OK
    withAppCrashIfException('requestProductCodesEpic', requestProductCodesEpic()),
    withAppCrashIfException('requestUnderlyingsBlackoutDates', underlyingsBlackoutDatesRequestedEpic()),
    withAppCrashIfException('requestUnderlyingsSpecificDates', underlyingsSpecificDatesRequestedEpic()),
  );
